import {
  UpdateCartPayload,
  CashBoxChangePayload,
  ProductReturnAttributesPayload,
  ProductReturnsPayload,
  CashBoxTransactionPayload
} from '../models';

export function deserializeUpdateCartPayload(payload: UpdateCartPayload): object | FormData {
  switch (payload.type) {
    case 'cartCouponCodeUpdate':
      return {
        coupon_code: payload.couponCode
      };
    case 'cartItemUpdate':
      return {
        id: payload.id,
        discount_type: payload.discountType,
        discount_amount: payload.discountAmount,
        quantity: payload.quantity
      };
    case 'cartNoteUpdate':
      return {
        note: payload.note
      };
    case 'cartAttributesUpdate':
      return {
        attributes: payload.attributes
      };
    case 'cartCustomerUpdate':
      const formData = new FormData();
      formData.set('pos_customer[email]', payload.customer.email);
      formData.set('pos_customer[accepts_newsletter]', payload.customer.acceptsNewsletter.toString());
      return formData;
    default:
      throw new Error(`Unsupported cart update payload type: ${(payload as any).type}`);
  }
}

export function deserializeCashBoxChangePayload(payload: CashBoxChangePayload): object {
  if (typeof payload !== 'object' || payload === null) {
    throw new Error(`CashBoxChangePayload should be a non null object, received ${typeof payload}.`);
  }
  return {
    user_id: payload.userId,
    current_amount: payload.currentAmount,
    spos_merchant_receipt: payload.sposMerchantReceipt,
    opi_merchant_receipt: payload.opiMerchantReceipt
  };
}

export function deserializeProductReturnsPayload(payload: ProductReturnsPayload): object {
  return {
    return: {
      transaction_id: payload.return.transactionId,
      items: payload.return.items,
      payment_type: payload.return.payment_type,
      card_type: payload.return.card_type,
    },
    user_id: payload.userId,
    pos_customer:
      payload.posCustomer?.email || payload.posCustomer?.acceptsNewsletter
        ? {
            email: payload.posCustomer.email,
            accepts_newsletter: payload.posCustomer.acceptsNewsletter,
          }
        : {},
  };
}

export function deserializeProductReturnAttributesPayload(payload: ProductReturnAttributesPayload): object {
  return {
    attributes: {
      ...payload.attributes
    },
  };
}

export function deserializeCashBoxAddTransaction(payload: CashBoxTransactionPayload) {
  return {
    type: payload.type,
    amount: payload.amount,
    category: payload.category,
    user_id: payload.userId
  };
}
